/* Benachrichtigungen nach dem Speichern eines Spielers auslösen.
 *
 * Vergleicht den zuletzt gespeicherten mit dem soeben gespeicherten Stand
 * (domain/playerEvents.js) und trägt je Ereignis eine Meldung ein. Aufgerufen
 * nur nach ERFOLGREICHEM Speichern — siehe PlayerPanel.vue, onSave. Ein
 * gescheitertes Speichern oder ein Verwerfen löst nichts aus.
 *
 * Fehler beim Eintragen bleiben folgenlos für den Nutzer (emitNotification
 * schreibt sie nur in die Konsole): Das Speichern ist dann schon gelungen,
 * und eine fehlende Meldung ist kein Grund, es als gescheitert anzuzeigen.
 *
 * Als Auslöser (created_by) wird die E-Mail-Adresse eingetragen, wie bisher.
 * Die Edge Function notify nimmt darüber den Auslöser vom Push aus.
 */

import { useAuth } from './useAuth.js';
import { emitNotification } from '../supabase/notifications.js';
import { diffPlayerEvents } from '../domain/playerEvents.js';

export function usePlayerEvents() {
  const { ownerStamp } = useAuth();

  /**
   * @param {object|null} before  zuletzt gespeicherter Stand
   * @param {object} after        soeben gespeicherter Stand
   */
  async function announceChanges(before, after) {
    const types = diffPlayerEvents(before, after);
    if (!types.length) return;
    const createdBy = ownerStamp().createdBy;
    await Promise.all(types.map((type) => emitNotification({ type, player: after, createdBy })));
  }

  return { announceChanges };
}
